<template lang="html">
  <div id="about-us-page-v2">
    <div class="img-bg" v-bind:style="{ backgroundImage: 'url(public/images/pages/about-us/image.jpg)' }"></div>

    <section class="container oversized-container main-section">
      <div class="row">
        <!-- <div class="col-lg-6 col-image">
          <img src="public/images/pages/about-us/image.jpg">
        </div> -->

        <div class="col-lg-6 text-justify col-info">
          <div class="mb-2 col-s-title">
            <h2 class="text-center title-s2">ANLESA</h2>
            <h3>Donde lo local se vuelve esencial.</h3>
          </div>

          <div class="text-justify">
            <p>
              En ANLESA nos apasiona dar valor a lo que se produce cerca de ti. Somos un marketplace creado para impulsar a pequeños y medianos productores locales y regionales, conectándolos con consumidores que aprecian la calidad, la tradición y el origen de cada producto.
            </p>
            <p class="mt-2">
              Creemos en el comercio justo, en apoyar a emprendedores auténticos y en fortalecer las economías regionales. Cada compra en ANLESA no solo lleva sabor, arte o cultura a tu hogar: también apoya historias reales, familias trabajadoras y comunidades enteras.
            </p>

            <p class="mt-3">
              Explora, apoya y consume con sentido.
            </p>

            <h5 class="mt-4 welcome">¡Bienvenido a ANLESA!</h5>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{
      content: '',
      image: ''
    }
  },

  methods: {
    getContent: function(){
      axios.get(tools.url('/api/nosotros')).then((response)=>{
        this.content = response.data;
      }).catch((error)=>{
        console.log(error);
      })
    }
  },

  beforeMount(){
    // this.getContent();
  }
}
</script>
